import { render } from "./ObjectiveName.vue?vue&type=template&id=2d8ea698&scoped=true"
import script from "./ObjectiveName.vue?vue&type=script&lang=js"
export * from "./ObjectiveName.vue?vue&type=script&lang=js"

import "./ObjectiveName.vue?vue&type=style&index=0&id=2d8ea698&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8ea698"]])

export default __exports__